<script>
import SlideComponent from '@/components/pages/components/SlideComponent.vue';
import BackgroundImage from '@/components/pages/components/Image.vue';

export default {
    components: { BackgroundImage, SlideComponent },
    props: {
        slide: {
            type: Object,
            default: () => {},
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        slideUrl() {
            return this.slide.url?.replace('https://bubblegumballoons.com', '');
        },
        slideLinkComponent() {
            if (this.slideUrl?.includes('http')) {
                return 'a';
            }

            if (this.slideUrl) {
                return 'nuxt-link';
            }

            return 'div';
        },
    },
};
</script>

<template>
    <div class="relative">
        <BackgroundImage
            v-if="slide.background"
            :component="slide.background"
            class="w-full h-full absolute inset-0"
            fit="cover"
            :width="1920"
        />

        <component
            :is="slideLinkComponent"
            :to="slideUrl"
            :href="slideUrl"
            :class="[`style-${slide.style} px-2 relative block`, slide.contain ? 'container mx-auto px-4 md:px-0' : '']"
        >
            <SlideComponent
                v-for="(component, index) in slide.components"
                :key="`component-${index}`"
                :component="component"
                :is-active="isActive"
            />
        </component>
    </div>

</template>

<style scoped lang="scss">

</style>
